import { doc, getFirestore, updateDoc } from "firebase/firestore";
import { queryMany, queryOne } from "./all";
import { userTable } from "../../helpers/tables";
import { getAuth } from "firebase/auth";
import { APP_NAME } from "../../helpers/constants";

const table = userTable;

const userModel = {
  create: async (data) => {
    console.log("Creating user profile");

    const user = getAuth().currentUser;
    if (!user) throw new Error("User not logged in");

    const username = user?.uid;
    console.log(username);

    const appSource = APP_NAME;

    const body = JSON.stringify({
      username,
      id: username,
      email: user?.email,
      appSource,
      ...data,
    });

    console.log(body);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/users`, {
        method: "POST",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        body,
      });

      const payload = await response.json().catch(() => ({}));
      if (!response.ok) {
        const msg =
          payload?.message ||
          payload?.error ||
          `Failed to create profile (${response.status})`;
        throw new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
      }
      return payload;
    } catch (error) {
      console.error("Error creating user profile:", error);
      throw error;
    }
  },
  getOneById: async (id) => {
    const data = await queryOne({ table, id });
    return data;
  },
  getMany: async (...args) => {
    const data = await queryMany({
      table,
      conditions: [...args],
    });
    return data;
  },
  update: async ({ id, data }) => {
    const userRef = doc(getFirestore(), table, id);

    // Prepare update data with usernameLowercase if username exists
    const updateData = {
      ...data,
    };

    // Only add usernameLowercase if username is provided
    if (data.username) {
      updateData.usernameLowercase = data.username.toLowerCase();
    }

    await updateDoc(userRef, updateData);
    return await queryOne({ table, id });
  },
};

export default userModel;
